import { useInfiniteQuery } from "@tanstack/react-query";

import type { paths } from "@/api/types";
import type { Result } from "@/shared/api";
import { apiGetPage, nextCursor, PAGE_LIMIT, qk } from "@/shared/api";

export type AuditEntry = Result<paths["/api/v1/admin/audit"]["get"]>[number];

export interface AuditFilters {
  adminId?: number | undefined;
  actions?: string[] | undefined;
  targetType?: string | undefined;
  targetId?: number | undefined;
}

export function useAudit(filters: AuditFilters) {
  return useInfiniteQuery({
    queryKey: qk.audit(filters as Record<string, unknown>),
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam, signal }) =>
      apiGetPage("/api/v1/admin/audit", {
        query: {
          limit: PAGE_LIMIT,
          ...(filters.adminId ? { admin_id: filters.adminId } : {}),
          ...(filters.actions?.length ? { action: filters.actions } : {}),
          ...(filters.targetType ? { target_type: filters.targetType } : {}),
          ...(filters.targetId ? { target_id: filters.targetId } : {}),
          ...(pageParam ? { cursor: pageParam } : {}),
        },
        signal,
      }),
    getNextPageParam: (last) => nextCursor(last.meta),
  });
}

/**
 * Действия, которые бывают в журнале. Список фиксирован здесь, а не собирается
 * из загруженных строк: фильтр обязан предлагать и то, чего на первой странице
 * не случилось.
 */
export const AUDIT_ACTIONS = [
  "login",
  "deposit_approve",
  "deposit_reject",
  "withdrawal_approve",
  "withdrawal_paid",
  "withdrawal_reject",
  "balance_adjust",
  "user_block",
  "user_unblock",
  "robot_create",
  "robot_update",
  "robot_reorder",
  "robot_offer_reset",
  "user_service_on",
  "user_service_off",
  "demo_reset",
  "comment_publish",
  "comment_hide",
  "comment_delete",
  "comment_reply",
  "comment_persona_create",
  "settings_update",
  "accrual_roll",
  "accrual_manual",
  "admin_create",
  "admin_update",
] as const;
